// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zRWJw77oa8GhoLlDayKe{display:inline-flex;flex-direction:column;align-items:flex-start;gap:8px}", "",{"version":3,"sources":["webpack://./src/aichat/views/flag-response-button.module.scss"],"names":[],"mappings":"AAAA,sBACE,mBAAA,CACA,qBAAA,CACA,sBAAA,CACA,OAAA","sourcesContent":[".flagWrapper {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flagWrapper": "zRWJw77oa8GhoLlDayKe"
};
export default ___CSS_LOADER_EXPORT___;
